import React from 'react'
import { DepositHeader } from '../index'
import SubmitBtn from '../Components/SubmitBtn'
import QRCodeView from '../Components/QRCodeView'
import CopyView from '../Components/CopyView'
import CHANNEL_NextStepCom from '$Deposits/Components/CTC/CHANNEL_NextStep'




class CHANNEL_NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showTrips: true,
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        return (
            <>

                <CHANNEL_NextStepCom
                    CHANNEL_NextStep={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            DepositBankActive,
                            backClick,
                            onChange,
                        } = propCon
                        const { deepLink, exchangeRate } = DepositPayments || {}
                        const { code } = DepositBankActive || {}
                        return (
                            <div className='nextModal'>
                                {/* <DepositHeader leftClick={backClick} title={MethodsActive && MethodsActive.name || 'Gửi Tiền'} /> */}
                                <div className='nextModalCenter'>
                                    <div className='viewArea'>
                                        <div className='CTCTitleIcon'>
                                            <div className={code + 'Icon'} />
                                            <span>{`Tether USD (${code})`}</span>
                                        </div>
                                        <div className='borders' />

                                        <div className='exchangeRate'>
                                            <p className='exchangeTitle'>อัตราแลกเปลี่ยน</p>
                                            <p className='exchangeValue'>1 {code} = {exchangeRate} THB</p>
                                        </div>

                                        <div className='redtip'>
                                            โปรดทราบ อัตราแลกเปลี่ยนเมื่อเสร็จสิ้นการทำธุรกรรมอาจแตกต่างกัน
                                        </div>

                                        <div className='borders' />

                                        {/* qrcode */}
                                        <div className='CTCqrcode'>
                                            <span>คิวอาร์โค้ด</span>
                                            <QRCodeView deepLink={deepLink} />
                                        </div>

                                        <div className='borders' />

                                        <p className='inputTitle'>ที่อยู่กระเป๋าเงิน</p>
                                        <div className='CTC_copy'>
                                            <div className='CTC_copyItem'>
                                                <CopyView
                                                    copyTitle={''}
                                                    copyValue={deepLink}
                                                    copyType={'deepLink'}
                                                />
                                            </div>
                                        </div>
                                        <div className='tipsBlue'>
                                            <p>จำนวนเงินฝากขั้นต่ำ: 1 {code}</p>
                                            <p>ที่อยู่กระเป๋าเงินนี้เป็นที่อยู่เฉพาะสำหรับคุณ และสามารถใช้ได้หลายครั้ง</p>
                                        </div>
                                    </div>
                                    <SubmitBtn
                                        submitBtn={() => { return true }}
                                        onPress={onChange}
                                        submitBtnItem={'ปิด'}
                                    />
                                </div>
                            </div>
                        )
                    }}

                />


            </>
        );
    }
}

export default CHANNEL_NextStep


